import type { ReactNode } from "react";
import { cx } from "./cx";
import { TONE_CLASSES, type Tone } from "./tone";

export interface PillProps {
  readonly tone?: Tone;
  readonly mono?: boolean;
  readonly title?: string;
  readonly children: ReactNode;
}

/** A small labelled lozenge: a tag, a source, a count. Not for status (use StatusChip). */
export function Pill({ tone = "muted", mono, title, children }: PillProps) {
  return (
    <span
      title={title}
      className={cx(
        "inline-flex items-center gap-1 rounded-pill border px-2 py-0.5 text-xs leading-none whitespace-nowrap",
        mono && "font-mono",
        TONE_CLASSES[tone].chip,
      )}
    >
      {children}
    </span>
  );
}
